import { render, staticRenderFns } from "./indices-card.vue?vue&type=template&id=063fde68&"
import script from "./indices-card.vue?vue&type=script&lang=js&"
export * from "./indices-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports